import API from "./lib/api";

export const getAllOnlineOrderDiscountOffersApi = async (restaurant_id, query = "") => {
  try {
    const { data } = await API.get(
      `restaurant/${restaurant_id}/order-online-and-get-discount-offers?${query}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleOnlineOrderDiscountOfferApi = async (id) => {
  try {
    const { data } = await API.get(
      `restaurant/order-online-and-get-discount-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const addOnlineOrderDiscountOfferApi = async (offerData) => {
  try {
    const { data } = await API.post(
      `restaurant/order-online-and-get-discount-offers`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const editOnlineOrderDiscountOfferApi = async (offerData, id) => {
  try {
    const { data } = await API.put(
      `restaurant/order-online-and-get-discount-offers/${id}`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteOnlineOrderDiscountOfferApi = async (id) => {
  try {
    const { data } = await API.delete(
      `restaurant/order-online-and-get-discount-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleOnlineOrderDiscountOfferStatusApi = async (id) => {
  try {
    const { data } = await API.put(
      `restaurant/order-online-and-get-discount-offers/${id}/toggle-status`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
